import script from "./setting.vue?vue&type=script&setup=true&lang=js"
export * from "./setting.vue?vue&type=script&setup=true&lang=js"

import "./setting.vue?vue&type=style&index=0&id=b764fc50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b764fc50"]])

export default __exports__